export default {
  methods: {
    // 获取位置
    areaGet(data) {
      this.$api.getPlace(data.value).then(res => {
        if (res.data.status === 0 ) {
          let _R = JSON.parse(res.data.data)
          switch(data.key) {
            case 0: this.province = _R; break;
            case 1: this.city = _R; break;
            case 2: this.county = _R; break;
            case 3: this.town = _R; break;
            case 4: this.village = _R; break;
            case 5: this.village = _R; break;
          }
        } else {
          this.$message.error('获取失败')
        }
      })
    },
    // 清空下级
    remoteMethod(value, num) {
      switch(num) {
        case 1: this.placeData[1] = this.placeData[2] = this.placeData[3] = this.placeData[4] = ''; break;
        case 2: this.placeData[2] = this.placeData[3] = this.placeData[4] = ''; break;
        case 3: this.placeData[3] = this.placeData[4] = ''; break;
        case 4: this.placeData[4] = ''; break;
      }
      if (value) {
        this.areaGet({ value: { areaId: value }, key: num })
      }
      let place = this.placeData.filter(x => x)
      if (place.length) {
        let areaId = place[place.length - 1]
        this.afterAreaGet && this.afterAreaGet(areaId)
      }
    },
    //设置默认地址
    getDefault() {
      if (this.userInfo.admin) {
        this.dis = [false, false, false, false, false]
      } else {
        this.$api.getFather({ areaId: this.userInfo.areaId }).then(res => {
          if (res.data.status === 0) {
            let _R = JSON.parse(res.data.data)
            _R.forEach((x, i) => {
              this.areaGet({ value: { areaId: x.id }, key: i + 1 })
              i === 5 ? this.dis.push(false) : this.dis.push(true)
              switch (x.level) {
                case 0: this.placeData[0] = x.id; break;
                case 1: this.placeData[1] = x.id; break;
                case 2: this.placeData[2] = x.id; break;
                case 3: this.placeData[3] = x.id; break;
                case 4: this.placeData[4] = x.id; break;
              }
            })
          } else { this._status(res.data) }
        })
      }
    },
  },
}